import { EventTypes, track } from '@mc/track-event'
import type { CheckoutWarningViewedProps } from '../../types'

export const trackCheckoutWarningViewed = ({
  email,
  message,
  messageCode,
  pageSource,
  props,
}: CheckoutWarningViewedProps) => {
  track(EventTypes.FIELD_ENTRY_WARNING_VIEWED, {
    email,
    warning_data_code: messageCode,
    warning_data_message: message,
    warning_type: 'email',
    page_source: pageSource,
    ...props,
  })
}
